<app-dashboarditem [title]="'Search'" className="hv-center">
  <div class="search-box w-75" style="margin-top: -70px">
    <input id="txtSearch" type="text" class="search-text" autofocus="autofocus" (keyup.enter)="runSearch()" placeholder="Search..." />
    <button class="search-button" title="Search" (click)="runSearch()">
      <span class="far fa-search"></span>
    </button>
  </div>
  <!--<div class="search-dash-saved">
    <div class="search-dash-saved-title">
      Saved Searches
    </div>
    <div class="search-dash-saved-item-container">
      <div class="search-dash-saved-item" *ngFor="let query of savedQueries">
        <ng-template #popContent>
          <div>Search Term: {{query.searchRequest.term}}</div>
          <div>Facets: {{query.searchRequest?.facets?.length}}</div>
          <div><hr /></div>
          <div>{{query.timestamp|datePreference}}</div>
        </ng-template>
        <div class="search-dash-saved-item-title" (click)="runSavedSearch(query.id)" [ngbPopover]="popContent" triggers="mouseenter:mouseleave" popoverTitle="{{query.name}}" [openDelay]="200" [closeDelay]="300">{{query.name}}</div>
      </div>
    </div>
  </div>-->
</app-dashboarditem>
